<template>
	<div class="block xs-12">
		<!-- Name -->
		<!-- <core-form-input
			name="name"
			componentName="j-base-input-text"
			:label="$t('name')"
			v-model="form.name"
			:validationErrors="errors"
		/>-->

		<!-- Organization 1 -->
		<core-form-input
			name="firstPartyEntity"
			componentName="core-select-organizations"
			:label="$t('first_party')"
			v-model="form.firstParty"
			:validationErrors="errors"
		/>

		<!-- Organization 2 -->
		<core-form-input
			class="mt6"
			name="secondPartyEntity"
			componentName="core-select-organizations"
			:label="$t('second_party')"
			v-model="form.secondParty"
			:validationErrors="errors"
		/>

		<!-- startDate  -->
		<core-form-input
			class="mt6"
			name="startDate"
			componentName="j-base-date-picker-simple"
			:label="$t('start_date')"
			v-model="form.startDate"
			:validationErrors="errors"
		/>

		<!-- endDate  -->
		<core-form-input
			class="mt6"
			name="endDate"
			componentName="j-base-date-picker-simple"
			:label="$t('end_date')"
			v-model="form.endDate"
			:validationErrors="errors"
		/>

		<!-- bindingDate  -->
		<core-form-input
			class="mt6"
			name="bindingDate"
			componentName="j-base-date-picker-simple"
			:label="$t('binding_date')"
			v-model="form.bindingDate"
			:validationErrors="errors"
		/>

		<!-- Commission rule -->
		<div class="fw7 mb1 mt6">Commission Rule for Product</div>
		<core-select-product v-model="form.product" />
		<commission-rule-input v-model="form.jsonRule" />

		<!-- HACK: -->
		<!-- We are hardcoding facts here because we don't want to bring the whole "schema thingy" we do in caseManagement here 
		as we first have to figure out how to do it via CMS-->
		<div v-for="(fact, i) in facts" :key="i">
			<core-form-input
				class="mt6"
				:name="`${fact.name} + ${i}`"
				:componentName="fact.componentName"
				:label="fact.label"
				v-model="fact.value"
				:validationErrors="errors"
			/>
		</div>

		<!-- Actions slot for buttons -->
		<slot name="actions" :onSubmit="onSubmit"></slot>
	</div>
</template>

<script>
/**
 * This component is responsible for rendering of fields for creation and update of Organizations
 */
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import CommissionRuleInput from "./CommissionRuleInput"
import CoreSelectProduct from "@/modules/core/components/CoreSelectProduct"

export default {
	components: { CoreFormInput, CommissionRuleInput, CoreSelectProduct },

	props: {
		data: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},

	data() {
		return {
			form: {}, // Will be populated from watcher in update case

			facts: [
				{
					type: "binderNumber",
					label: "Binder Number",
					componentName: "j-base-input-text",
					dataType: "string",
					value: null
				},
				{
					type: "acCode",
					label: "A/C Code",
					componentName: "j-base-input-text",
					dataType: "string",
					value: null
				}
			]
		}
	},

	methods: {
		/**
		 * When form is valid this method emits input event with this.form as payload
		 */
		async onSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			// First argument is data in shape that API expects for update and create
			// Second argument is list of facts
			this.$emit(
				"submit",
				{
					// name: this.form.name,
					endDate: this.form.endDate,
					startDate: this.form.startDate,
					bindingDate: this.form.bindingDate,
					firstPartyEntityId: this.form?.firstParty?.[0]?.id,
					secondPartyEntityId: this.form?.secondParty?.[0]?.id,
					commissionRule: {
						jsonRule: this.form?.jsonRule,
						productId: this.form?.product?.[0]?.productId
					}
				},
				this.facts.map(item => ({
					type: item.type,
					id: item.id,
					value: { [`${item.dataType}Value`]: item.value }
				}))
			)
		}
	},

	watch: {
		data: {
			handler() {
				// Pepopulate form state with data that was passed in data prop
				const { startDate, endDate, bindingDate, name } = this.data

				// Form
				this.form = {
					startDate,
					endDate,
					bindingDate,
					name,
					firstParty: this.data?.firstParty
						? [
								{
									value: this.data?.firstParty?.id,
									name: this.data?.firstParty?.name
								}
						  ]
						: [],
					secondParty: this.data?.secondParty
						? [
								{
									value: this.data?.secondParty?.id,
									name: this.data?.secondParty?.name
								}
						  ]
						: [],
					jsonRule: this.data?.commissionRule?.jsonRule || "",
					product: this.data?.commissionRule?.product
						? [this.data?.commissionRule?.product]
						: []
				}

				// Facts
				this.facts = this.facts.map(fact => {
					const found = this.data?.facts?.find(d => d.type === fact.type) || {}

					// Merge schema facts with data
					return {
						...fact,
						id: found.id,
						value: found?.value?.[`${fact.dataType}Value`] || null
					}
				})
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
